(ns common.time
  (:refer-clojure :exclude [format])
  #?(:cljs (:require
            [common.dates :as dates]
            [cljs.reader :as edn]))
  #?(:clj
     (:require
      [common.dates :as dates]))
  #?(:clj
     (:import
      (java.time LocalDate)
      (org.joda.time DateTimeFieldType))))

(def rfc-3339-pattern "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")

(def roughly-one-year-in-millis (* 1000 3600 24 365))
(def minute-in-millis 60000)
(def minutes-in-millis-10 600000)

(defn now-millis
  []
  #?(:cljs (.getTime (js/Date.))
     :clj  (System/currentTimeMillis)))

(defn now-day-of-month
  []
  #?(:cljs (->> (js/Date.)
                (.getDate))
     :clj  (let [today (LocalDate/now)]
             (.getDayOfMonth today))))

(defn now-month-of-year
  []
  #?(:cljs (->> (js/Date.)
                (.getMonth)
                (inc))
     :clj  (let [today (LocalDate/now)]
             (.getMonthValue today))))

(defn now-year
  []
  #?(:cljs (->> (js/Date.)
                (.getFullYear))
     :clj  (let [today (LocalDate/now)]
             (.getYear today))))

(defn now-date-parts
  []
  #?(:cljs (let [d (js/Date.)]
             [(->> d
                   (.getDate))
              (->> d
                   (.getMonth)
                   (inc))
              (->> d
                   (.getFullYear))])
     :clj  (let [d (LocalDate/now)]
             [(->> d
                   (.getDayOfMonth))
              (->> d
                   (.getMonthValue))
              (->> d
                   (.getYear))])))

(defn date-parts
  [common-date]
  #?(:cljs [(->> common-date
                 (.getDate))
            (->> common-date
                 (.getMonth)
                 (inc))
            (->> common-date
                 (.getFullYear))]
     :clj  [(->> common-date
                 (.getDayOfMonth))
            (->> common-date
                 (.getMonthOfYear))
            (->> common-date
                 (.getYear))]))

(defn now-utc
  []
  (dates/date-time))

(defn date->millis
  [date]
  #?(:cljs (.getTime date)
     :clj  (.getMillis date)))

(defn str->millis
  [epoch-str]
  #?(:cljs (edn/read-string epoch-str)
     :clj  (.getMillis epoch-str)))

(defn date-str->millis
  [value & [_format]]
  (if-not (string? value)
    value

    (let [dt-val (cond
                   (empty? value) 0
                   (re-matches #"^\d*" value) (str->millis value)
                   (re-matches #"^(\d{4})/([0-1][0-9])/([0-3][0-9])" value) (dates/date value {:pattern "yyyy/MM/dd"})
                   (re-matches #"^(\d{4})/([0-3][0-9])/([0-1][0-9])" value) (dates/date value {:pattern "yyyy/dd/MM"})
                   (re-matches #"^(\d{4}).([0-1][0-9]).([0-3][0-9])" value) (dates/date value {:pattern "yyyy.MM.dd"})
                   (re-matches #"^(\d{4}).([0-3][0-9]).([0-1][0-9])" value) (dates/date value {:pattern "yyyy.dd.MM"}))
          ms-val (when dt-val
                   (cond (number? dt-val) dt-val
                         :else (date->millis dt-val)))]
      ms-val)))

(defn quarter-str
  [_d m y]
  (let [[Q year] (case m
                   (1 2 3) [1 y]
                   (4 5 6) [2 y]
                   (7 8 9) [3 y]
                   (10 11 12) [4 y])]
    (str Q "Q" year)))

(defn start-of-month-millis
  [dt]
  (let [dt (dates/start-of-month dt)]
    (- (date->millis dt)
       (* 1000
          60
          #?(:cljs (.getTimezoneOffset dt)
             :clj  0                                                                                ;(.getTimezoneOffset dt)
             )))))

(defn end-of-month-millis
  [dt]
  (let [dt (dates/end-of-month dt)]
    (- (date->millis dt)
       (* 1000
          60
          #?(:cljs (.getTimezoneOffset dt)
             :clj  0                                                                                ;  (.getTimezoneOffset dt)
             )))))

(defn start-of-q-millis
  [dt]
  (let [q-start-month (dates/plus dt
                                  (dates/months
                                   (case (mod #?(:cljs (inc (.getMonth dt))
                                                 :clj  (.get dt (DateTimeFieldType/monthOfYear))) 3)
                                     0 -2
                                     1 0
                                     2 -1)))]
    (start-of-month-millis q-start-month)))

(defn end-of-q-millis
  [dt]
  (let [months-till-end-of-q (case (mod #?(:cljs (inc (.getMonth dt))
                                           :clj  (.get dt (DateTimeFieldType/monthOfYear))) 3)
                               0 0
                               1 2
                               2 1)
        q-end-month (dates/plus dt
                                (dates/months months-till-end-of-q))]
    (end-of-month-millis q-end-month)))

(defn start-of-h-millis
  [dt]
  (let [offset (mod (dec #?(:cljs (inc (.getMonth dt))
                            :clj  (.get dt (DateTimeFieldType/monthOfYear)))) 6)
        h-start-month (dates/plus dt (dates/months (- offset)))]
    (start-of-month-millis h-start-month)))

(defn end-of-h-millis
  [dt]
  (let [offset (mod (dec #?(:cljs (inc (.getMonth dt))
                            :clj  (.get dt (DateTimeFieldType/monthOfYear)))) 6)
        h-end-month (dates/plus dt (dates/months (- 5 offset)))]
    (end-of-month-millis h-end-month)))
